/**
 * Utility functions used across multiple modules.
 */
export function decodeHTMLEntities(text) {
    if (!text) return '';
    const tempElement = document.createElement("textarea");
    tempElement.innerHTML = text;
    return tempElement.value;
}